import React from 'react';

const BorderedPanel = ({ children }) => <div className='bordered-panel'>{children}</div>;

export default BorderedPanel;
